import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

/**
 * Stands in for MsalGuard when environment.useMockAuth is true (see app.module.ts), so routes
 * are reachable without a real Azure AD B2C redirect flow during local development.
 */
@Injectable({ providedIn: 'root' })
export class MockMsalGuard implements CanActivate {
  canActivate(): boolean {
    return true;
  }
}
